module.exports = __webpack_public_path__ + "img/22.b61f3fb5.png";